import { useState } from "react";
import { REGIONS, PORTS, MAP_W, MAP_H } from "@/data/mapData";
import { PORT_REGIONS } from "@/data/content";

export const ExportMap = () => {
  const [active, setActive] = useState(null);
  const hovered = PORTS.find((p) => p.name === active);

  return (
    <div data-testid="export-map" className="grid gap-10 lg:grid-cols-12 items-center">
      <div className="relative lg:col-span-8 order-2 lg:order-1">
        <svg
          viewBox={`0 0 ${MAP_W} ${MAP_H}`}
          className="w-full h-auto"
          style={{ maxHeight: "72vh" }}
          role="img"
          aria-label="Map of ports served across Africa and the Gulf"
        >
          {REGIONS.map((r) => (
            <path
              key={r.id}
              d={r.rings.map((pts) => `M${pts.map((p) => p.join(",")).join("L")}Z`).join(" ")}
              fill="#4A2E20"
              stroke="#8a6a4f"
              strokeWidth="0.8"
              opacity="0.95"
            />
          ))}
          {REGIONS.map((r) => {
            const pts = r.rings[0];
            const area = Math.abs(pts.reduce((s, p, i) => {
              const q = pts[(i + 1) % pts.length];
              return s + p[0] * q[1] - q[0] * p[1];
            }, 0)) / 2;
            const all = r.rings.flat();
            const cx = all.reduce((s, p) => s + p[0], 0) / all.length;
            const cy = all.reduce((s, p) => s + p[1], 0) / all.length;
            return (
              <text
                key={`${r.id}-label`}
                x={cx}
                y={cy}
                fontSize={area < 900 ? 9 : 11.5}
                textAnchor="middle"
                fill="#F5EDDD"
                opacity="0.6"
                style={{ fontFamily: "'Space Mono', monospace", letterSpacing: "0.08em", pointerEvents: "none" }}
              >
                {r.name}
              </text>
            );
          })}
          {PORTS.map((p) => {
            const on = active === p.name;
            return (
              <g
                key={p.name}
                transform={`translate(${p.x},${p.y})`}
                onMouseEnter={() => setActive(p.name)}
                onMouseLeave={() => setActive(null)}
                data-testid={`map-pin-${p.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                style={{ cursor: "pointer" }}
              >
                <circle r="16" fill="transparent" />
                <circle r="10" fill="#D99C41" opacity={on ? 0.35 : 0} className="animate-pulsepin" />
                <circle r={on ? 7 : 4.5} fill="#D99C41" stroke="#2C1A14" strokeWidth="1.5" style={{ transition: "r .25s" }} />
              </g>
            );
          })}
        </svg>
        {hovered && (
          <div
            data-testid="map-tooltip"
            className="pointer-events-none absolute z-10 -translate-x-1/2 -translate-y-full rounded-full bg-brand-cream px-4 py-1.5 text-xs font-bold text-brand-choc shadow-xl"
            style={{ left: `${(hovered.x / MAP_W) * 100}%`, top: `${(hovered.y / MAP_H) * 100}%` }}
          >
            {hovered.name} · {hovered.country}
          </div>
        )}
      </div>

      <div className="lg:col-span-4 order-1 lg:order-2 space-y-8">
        {PORT_REGIONS.map((r) => (
          <div key={r.region}>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-brand-gold">{r.region}</p>
            <p className="mt-2 text-sm leading-relaxed text-brand-cream/75">
              {r.ports.join(" · ")}
            </p>
          </div>
        ))}
        <p className="text-sm leading-relaxed text-brand-cream/60 border-l-2 border-brand-gold pl-4">
          Factory stuffing into 40ft high-cube containers for all major global ports — direct and merchant exports.
        </p>
      </div>
    </div>
  );
};

export default ExportMap;
